module.exports = __webpack_public_path__ + "static/media/capsules.9c28843b.svg";